module.exports = __webpack_public_path__ + "img/bg_function01_3_d.04270d57.png";